<template>
  <div class="row g-4">
    <div v-if="checkins && checkins.length > 0 && !isEditMode && checkInInstant" class="col-12 mt-20">
      <div class="form-check">
        <input
          id="usarDatosCheckin"
          class="form-check-input"
          type="checkbox"
          :checked="usarDatosCheckin"
          @change="handleUsarDatosCheckinChange" />
        <label class="form-check-label" for="usarDatosCheckin">
          {{ $t('reserva.datosFiscales.usarDatosAsistente') }}
        </label>
      </div>

      <div v-if="usarDatosCheckin" class="mb-2 mt-10">
        <InputSelector
          v-model="selectedCheckinIndex"
          :options="checkinsOptions"
          :placeholder="$t('reserva.checkIn.placeholders.seleccionaTipo')" />
      </div>
    </div>

    <div class="col-12 mt-20">
      <label class="fw-medium fs-16 fs-m-13 text-primary mb-2">{{ $t('reserva.datosFiscales.tipo') }}</label>
      <InputSelector
        v-model="formularioData.tipo"
        :options="tipoDatosFiscalesOptions"
        :placeholder="$t('reserva.checkIn.placeholders.seleccionaTipo')" />
    </div>

    <template
      v-if="
        formularioData.tipo === TIPO_DATOS_FISCALES.EMPRESA || formularioData.tipo === TIPO_DATOS_FISCALES.AUTONOMO
      ">
      <div class="col-12">
        <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{
          $t('reserva.datosFiscales.razonSocial')
        }}</label>
        <input
          v-model="formularioData.razonSocial"
          class="form-control bg-light border-0 py-3"
          :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
      </div>
    </template>

    <template v-if="formularioData.tipo === TIPO_DATOS_FISCALES.PARTICULAR">
      <div class="col-12 col-md-6">
        <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.nombre') }}</label>
        <input
          v-model="formularioData.nombre"
          class="form-control bg-light border-0 py-3"
          :disabled="checkin"
          :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
      </div>
      <div class="col-12 col-md-6">
        <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{
          $t('reserva.datosFiscales.apellidos')
        }}</label>
        <input
          v-model="formularioData.apellidos"
          class="form-control bg-light border-0 py-3"
          :disabled="checkin"
          :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
      </div>
    </template>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 fs-m-13 text-primary small mb-2">{{
        $t('reserva.datosFiscales.telefono')
      }}</label>
      <input
        v-model="formularioData.telefono"
        class="form-control bg-light border-0 py-3"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.email') }}</label>
      <input
        v-model="formularioData.email"
        class="form-control bg-light border-0 py-3"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label
        v-if="formularioData.tipo === TIPO_DATOS_FISCALES.PARTICULAR"
        class="fw-medium fs-16 fs-m-13 text-primary small mb-2"
        >{{ $t('reserva.datosFiscales.idFiscalParticular') }}</label
      >
      <label v-else class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{
        $t('reserva.datosFiscales.idFiscalEmpresa')
      }}</label>
      <input
        v-model="formularioData.idFiscal"
        class="form-control bg-light border-0 py-3"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.pais') }}</label>
      <InputSelector
        v-model="formularioData.paisCode"
        :options="countryList"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.seleccionaPais')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.direccion') }}</label>
      <input
        v-model="formularioData.direccion"
        class="form-control bg-light border-0 py-3"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{
        $t('reserva.datosFiscales.codigoPostal')
      }}</label>
      <input
        v-model="formularioData.codigoPostal"
        class="form-control bg-light border-0 py-3"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.poblacion') }}</label>
      <input
        v-model="formularioData.poblacion"
        class="form-control bg-light border-0 py-3"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>

    <div class="col-12 col-md-6">
      <label class="fw-medium fs-16 fs-m-13 text-primary small mb-2">{{ $t('reserva.datosFiscales.provincia') }}</label>
      <input
        v-model="formularioData.provincia"
        class="form-control bg-light border-0 py-3"
        :disabled="checkin"
        :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
    </div>
  </div>
</template>

<script setup>
  import { computed, onBeforeMount, reactive, ref, watch } from 'vue';
  import countries from 'i18n-iso-countries';
  import enLocale from 'i18n-iso-countries/langs/en.json';
  import esLocale from 'i18n-iso-countries/langs/es.json';
  import frLocale from 'i18n-iso-countries/langs/fr.json';
  import itLocale from 'i18n-iso-countries/langs/it.json';
  import ptLocale from 'i18n-iso-countries/langs/pt.json';
  import Cookies from 'js-cookie';
  import { useUserStore } from '@/store_pinia/userStore';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { useI18n } from 'vue-i18n';
  import InputSelector from '@/components/inputs/InputSelector.vue';
  import { TIPO_DATOS_FISCALES } from '@/constants/datosFiscalesConstants';

  const props = defineProps({
    checkins: {
      type: Array,
      default: () => [],
    },
    datosFiscales: {
      type: Object,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  });

  const { t } = useI18n();
  const userStore = useUserStore();
  const storeHabitacion = informacionHabitacion();
  const countryList = ref({});
  const usarDatosCheckin = ref(false);
  const selectedCheckinIndex = ref(null);
  const formularioData = reactive({
    tipo: TIPO_DATOS_FISCALES.PARTICULAR,
    razonSocial: '',
    nombre: '',
    apellidos: '',
    paisCode: '',
    direccion: '',
    poblacion: '',
    codigoPostal: '',
    provincia: '',
    idFiscal: '',
    email: '',
    telefono: '',
  });

  const tipoDatosFiscalesOptions = {
    [TIPO_DATOS_FISCALES.EMPRESA]: t('reserva.datosFiscales.tipoEmpresa'),
    [TIPO_DATOS_FISCALES.AUTONOMO]: t('reserva.datosFiscales.tipoAutonomo'),
    [TIPO_DATOS_FISCALES.PARTICULAR]: t('reserva.datosFiscales.tipoParticular'),
  };

  const checkInInstant = computed(() => storeHabitacion.getViaje?.formularioInscripcion?.checkInInstant);

  const checkinsOptions = computed(() => {
    if (!props.checkins || props.checkins.length === 0) return {};
    return props.checkins.reduce((acc, checkin, index) => {
      acc[index] = `${checkin.nombre} ${checkin.apellidos}`.trim();
      return acc;
    }, {});
  });

  const checkin = computed(() => {
    return usarDatosCheckin.value && selectedCheckinIndex.value !== null && props.checkins[selectedCheckinIndex.value]
      ? props.checkins[selectedCheckinIndex.value]
      : null;
  });

  const isFormValid = computed(() => {
    const nombreValido =
      formularioData.tipo === TIPO_DATOS_FISCALES.PARTICULAR
        ? formularioData.nombre !== '' && formularioData.apellidos !== ''
        : formularioData.tipo === TIPO_DATOS_FISCALES.EMPRESA || formularioData.tipo === TIPO_DATOS_FISCALES.AUTONOMO
        ? formularioData.razonSocial !== ''
        : true;

    return (
      formularioData.tipo !== '' &&
      nombreValido &&
      formularioData.paisCode !== '' &&
      formularioData.direccion !== '' &&
      formularioData.poblacion !== '' &&
      formularioData.codigoPostal !== '' &&
      formularioData.provincia !== '' &&
      formularioData.idFiscal !== '' &&
      formularioData.telefono !== '' &&
      formularioData.email !== ''
    );
  });

  function fillWithDatosUsuario() {
    if (props.isEditMode || props.datosFiscales) {
      return;
    }

    const usuario = userStore.getUsuario;
    if (!formularioData.nombre) formularioData.nombre = usuario?.nombre || '';
    if (!formularioData.apellidos) formularioData.apellidos = usuario?.apellidos || '';
    if (!formularioData.email) formularioData.email = usuario?.email || '';
    if (!formularioData.direccion) formularioData.direccion = usuario?.direccion || '';
    if (!formularioData.poblacion) formularioData.poblacion = usuario?.poblacion || '';
    if (!formularioData.provincia) formularioData.provincia = usuario?.provincia || '';
    if (!formularioData.codigoPostal) formularioData.codigoPostal = usuario?.codigoPostal || '';
    if (!formularioData.telefono) formularioData.telefono = usuario?.telefono || '';
    if (!formularioData.paisCode) formularioData.paisCode = usuario?.paisCode || usuario?.paisId || '';
  }

  function initCountrySelector() {
    countries.registerLocale(esLocale);
    countries.registerLocale(enLocale);
    countries.registerLocale(frLocale);
    countries.registerLocale(itLocale);
    countries.registerLocale(ptLocale);
    countryList.value = Object.entries(countries.getNames(Cookies.get('lang')))
      .sort(([, a], [, b]) => a.localeCompare(b))
      .reduce((sorted, [code, name]) => {
        sorted[code] = name;
        return sorted;
      }, {});
  }

  function fillWithCheckin(data) {
    if (!data) return;
    formularioData.direccion = data.direccion || '';
    formularioData.codigoPostal = data.codigoPostal || '';
    formularioData.paisCode = data.pais || '';
    formularioData.nombre = data.nombre || '';
    formularioData.apellidos = data.apellidos || '';
    formularioData.idFiscal = data.dni || '';
    formularioData.poblacion = data.poblacion || '';
    formularioData.provincia = data.provincia || '';
  }

  function cleanCheckin() {
    formularioData.direccion = '';
    formularioData.codigoPostal = '';
    formularioData.paisCode = '';
    formularioData.nombre = '';
    formularioData.apellidos = '';
    formularioData.idFiscal = '';
    formularioData.poblacion = '';
    formularioData.provincia = '';
  }

  function handleUsarDatosCheckinChange(event) {
    usarDatosCheckin.value = event.target.checked;
    selectedCheckinIndex.value = event.target.checked && props.checkins?.length > 0 ? 0 : null;
  }

  function resetForm() {
    formularioData.tipo = TIPO_DATOS_FISCALES.PARTICULAR;
    formularioData.razonSocial = '';
    formularioData.nombre = '';
    formularioData.apellidos = '';
    formularioData.paisCode = '';
    formularioData.direccion = '';
    formularioData.poblacion = '';
    formularioData.codigoPostal = '';
    formularioData.provincia = '';
    formularioData.idFiscal = '';
    formularioData.email = '';
    formularioData.telefono = '';
    fillWithDatosUsuario();
  }

  function loadDatosFiscales(datosFiscales) {
    if (datosFiscales) {
      formularioData.tipo = datosFiscales.tipo || TIPO_DATOS_FISCALES.PARTICULAR;
      formularioData.razonSocial = datosFiscales.razonSocial || '';
      formularioData.nombre = datosFiscales.nombre || '';
      formularioData.apellidos = datosFiscales.apellidos || '';
      formularioData.paisCode = datosFiscales.paisCode || '';
      formularioData.direccion = datosFiscales.direccion || '';
      formularioData.poblacion = datosFiscales.poblacion || '';
      formularioData.codigoPostal = datosFiscales.codigoPostal || '';
      formularioData.provincia = datosFiscales.provincia || '';
      formularioData.idFiscal = datosFiscales.idFiscal || '';
      formularioData.email = datosFiscales.email || '';
      formularioData.telefono = datosFiscales.telefono || '';
    }
  }

  watch(
    () => [usarDatosCheckin.value, selectedCheckinIndex.value],
    ([isChecked, index]) => {
      if (props.isEditMode || props.datosFiscales) {
        return;
      }

      if (!isChecked) {
        cleanCheckin();
        fillWithDatosUsuario();
      } else if (index !== null && props.checkins[index]) {
        fillWithCheckin(props.checkins[index]);
      }
    }
  );

  watch(
    () => props.checkins,
    newCheckins => {
      if (usarDatosCheckin.value && selectedCheckinIndex.value !== null && !props.isEditMode && !props.datosFiscales) {
        const checkinSeleccionado = newCheckins[selectedCheckinIndex.value];
        if (checkinSeleccionado) {
          fillWithCheckin(checkinSeleccionado);
        }
      }
    },
    { deep: true }
  );

  onBeforeMount(() => {
    initCountrySelector();
    if (props.datosFiscales) {
      loadDatosFiscales(props.datosFiscales);
    } else {
      fillWithDatosUsuario();
    }
  });

  defineExpose({
    formularioData,
    isFormValid,
    resetForm,
    loadDatosFiscales,
    fillWithCheckin,
  });
</script>

<style scoped lang="scss">
  .form-control,
  .form-select {
    background-color: rgba(32, 36, 68, 0.02) !important;
    box-shadow: 0 0 3px 0 rgba(32, 36, 68, 0.35) inset !important;
    border: none !important;
    height: 40px !important;
    padding: 0.375rem 0.75rem !important;
    text-align: left !important;
  }

  .form-control,
  .form-select {
    &:disabled {
      background-color: white !important;
      opacity: 0.7 !important;
    }
  }

  .form-check-input[type='checkbox'] {
    cursor: pointer;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.3);

    &:checked {
      background-color: var(--bs-secondary);
      border-color: var(--bs-secondary);
    }

    &:focus {
      box-shadow: none;
    }
  }

  @media screen and (max-width: 768px) {
    .form-control,
    .form-select,
    .form-check-label,
    input::placeholder,
    select,
    .input-group-text {
      font-size: 13px !important;
    }
  }
</style>
